import React from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  codeTableTypeState,
  popupState,
  refreshTables,
  updatedRecord,
  updatedRecordType3,
} from "../../../../Store/atoms";
import { useForm, Controller } from "react-hook-form";

import "./styles.css";
import { makeStyles } from "@material-ui/core";
import { TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { blurRoot, unBlurRoot } from "../../../../Utilities/DOMFunctions";
import {
  IOmniumType,
  ISubmitEditForm,
  PopupType,
} from "../../../../Models/Entities";
import { BASE_URL, extractId, sendData } from "../../../../Models/Fetcher";
import { useLocation } from "react-router-dom";
import TextValueInput from "../../TextValueInput";

interface IEditRecordProps {
  type: PopupType;
  omniumType: IOmniumType | null;
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    flexWrap: "wrap",
    alignItems: "center",
    padding: theme.spacing(2),

    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "300px",
    },
    "& .MuiButtonBase-root": {
      margin: theme.spacing(2),
    },
  },
  editRecord: {
    position: "fixed",

    top: "50%",
    right: "50%",

    padding: "2rem",
    transform: "translate(50%, -50%)",
    zIndex: 2,

    backgroundColor: "white",
    borderRadius: "10px",
    border: "2px solid #2981b7",
  },
}));

export default ({ type, omniumType }: IEditRecordProps) => {
  const currentLocation = useLocation();
  const classes = useStyles();
  const record2 = useRecoilValue(updatedRecord);
  const record3 = useRecoilValue(updatedRecordType3);
  const setPopup = useSetRecoilState(popupState);
  const setRefresh = useSetRecoilState(refreshTables);
  const recordTableType = useRecoilValue(codeTableTypeState);

  let record: any = recordTableType === 3 ? record3 : record2;

  const { handleSubmit, control } = useForm();

  const tableId = extractId(currentLocation.pathname);

  blurRoot();

  const onCreateSubmit = async (data: ISubmitEditForm) => {
    unBlurRoot();
    const postURL = BASE_URL + "records-" + recordTableType;
    const typeId = omniumType === null ? record?.type_id : omniumType.id;

    const response = await sendData(postURL, "POST", {
      ...data,
      omnium_id: typeId,
      table_id: tableId,
    });

    setRefresh(typeId);

    setPopup(null);
  };

  const onEditSubmit = async (data: any) => {
    unBlurRoot();
    const updateURL =
      BASE_URL + "records-" + recordTableType + "/" + record?.id;
    const response = await sendData(updateURL, "PUT", {
      ...data,
      omnium_id: record?.type_id,
      table_id: tableId,
    });

    if (record) {
      setRefresh(record.type_id);
    }

    setPopup(null);
  };

  const handleClose = () => {
    unBlurRoot();
    setPopup(null);
  };

  const newRecord = type === PopupType.AddRecord;

  const formItems = [
    recordTableType === 2 && {
      name: "omnium_value",
      required: true,
      label: "Omnium Value",
      errorMsg: "Value required",
      defaultValue: newRecord ? "" : record?.omnium_value,
      forType: 2,
    },
    {
      name: "customer_value",
      required: true,
      label: "Customer Value",
      errorMsg: "Value required",
      defaultValue: newRecord ? "" : record?.customer_value,
      forType: 3,
    },
    {
      name: "de_value",
      required: false,
      label: "De value",
      errorMsg: "",
      defaultValue: newRecord ? "" : record?.de_value,
      forType: 3,
    },
    {
      name: "en_value",
      required: false,
      label: "En value",
      errorMsg: "",
      defaultValue: newRecord ? "" : record?.en_value,
      forType: 3,
    },
    {
      name: "fr_value",
      required: false,
      label: "Fr value",
      errorMsg: "",
      defaultValue: newRecord ? "" : record?.fr_value,
      forType: 3,
    },
    {
      name: "it_value",
      required: false,
      label: "It value",
      errorMsg: "",
      defaultValue: newRecord ? "" : record?.it_value,
      forType: 3,
    },
  ];

  const formItems2 = [
    {
      name: "order",
      required: false,
      label: "Order",
      errorMsg: "",
      defaultValue: newRecord ? "" : record?.order,
      forType: 3,
    },

    {
      name: "master",
      required: false,
      label: "Master",
      errorMsg: "",
      defaultValue: newRecord ? "" : record?.master,
      forType: 3,
    },

    recordTableType === 2 && {
      name: "de_abbr",
      required: false,
      label: "De value",
      errorMsg: "",
      defaultValue: newRecord ? "" : record?.de_abbr,
      forType: 2,
    },
    recordTableType === 2 && {
      name: "en_abbr",
      required: false,
      label: "En abbr",
      errorMsg: "",
      defaultValue: newRecord ? "" : record?.en_abbr,
      forType: 2,
    },
    recordTableType === 2 && {
      name: "fr_abbr",
      required: false,
      label: "Fr abbr",
      errorMsg: "",
      defaultValue: newRecord ? "" : record?.fr_abbr,
      forType: 2,
    },
    recordTableType === 2 && {
      name: "it_abbr",
      required: false,
      label: "It abbr",
      errorMsg: "",
      defaultValue: newRecord ? "" : record?.it_abbr,
      forType: 2,
    },
  ];

  return (
    <div className={classes.editRecord}>
      <form
        className={classes.root}
        onSubmit={handleSubmit(
          type === PopupType.EditRecord ? onEditSubmit : onCreateSubmit
        )}
      >
        <div className="form-items">
          <div className="form__item">
            {formItems.map((item) => {
              if (!item) {
                return null;
              }
              return (
                <TextValueInput
                  name={item.name}
                  control={control}
                  required={item.required}
                  label={item.label}
                  errorMsg={item.errorMsg}
                  defaultValue={item.defaultValue}
                />
              );
            })}
          </div>
          <div className="form__item">
            {formItems2.map((item) => {
              if (!item) {
                return null;
              }

              return (
                <TextValueInput
                  name={item.name}
                  control={control}
                  required={item.required}
                  label={item.label}
                  errorMsg={item.errorMsg}
                  defaultValue={item.defaultValue}
                />
              );
            })}
          </div>
        </div>
        <div className="button-control">
          <Button variant="contained" onClick={handleClose}>
            Cancel
          </Button>
          <Button type="submit" variant="contained" color="primary">
            Confirm
          </Button>
        </div>
      </form>
    </div>
  );
};
